import { AdminJobs } from "go-component/components/AdminJob";
import { api } from "../../../../../../services/Api/api";

export const JobsIndexPage = () => {
	return (
		<div className="content">
			<AdminJobs fetchRequest={api.getJobs} />
		</div>
	);
};
